import React, { createContext, useContext } from 'react'
import useConfigStepsStorage from '../hooks/localStorage/useConfigStepsStorage';

const ConfigStepsContext = createContext();

//@Deprecated. Still in use but should be deleted and replaced with calculation according to current configPath, instead of maintaining config steps.
export default function ConfigStepsContextProvider({children}) {
  const ops = useConfigStepsStorage();
  return (
    <ConfigStepsContext.Provider value={ops}>
    {children}
    </ConfigStepsContext.Provider>
  )
}

export function useConfigStepsContext() {
  return useContext(ConfigStepsContext);
}